import React, { memo } from 'react'

import { Icon, InfoOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, object } from 'prop-types'

import WithListingPageContext from 'Pods/ListingPage/Components/WithListingPageContext'
import i18n from 'Pods/Shared/I18n'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

import Form from './Form'
import Submit from './Submit'
import Tags from './Tags'
import { SearchSubscriptionProvider } from '../Context/SearchSubscriptionContext'

function SubscribeCard({ selectedFilters = EMPTY_OBJECT, pageCategory = '', currentTotalCount = EMPTY_OBJECT, locale = 'en' }) {
  const title = i18n.t('listingPage.footerBanners.searchSubscription.title', { ns: 'rails', lng: locale })
  const description = i18n.t('listingPage.footerBanners.searchSubscription.description', { ns: 'rails', lng: locale })

  return (
    <SearchSubscriptionProvider
      selectedFilters={selectedFilters}
      pageCategory={pageCategory}
      currentTotalCount={currentTotalCount}
    >
      <div className="search-subscription__card cgt-card cgt-card--inner-space is-rounded cgt-card--border">
        <h5 className="search-subscription__title cgt-legacy-heading-h4">
          {title}
        </h5>
        <Form locale={locale} />
        <Tags />

        <div className="search-subscription__info">
          <Icon
            color="dark"
            size="small"
            svgComponent={InfoOutlined}
            withHover
          />
          <span className="search-subscription__info-text">
            {description}
          </span>
        </div>

        <div className="search-subscription__button-group">
          <Submit locale={locale} />
        </div>
      </div>
    </SearchSubscriptionProvider>
  )
}

SubscribeCard.propTypes = {
  selectedFilters: object,
  pageCategory: string,
  currentTotalCount: object,
  locale: string,
}

const mapStateToProps = ({
  pageCategory,
  selectedFilters,
  currentTotalCount,
  locale,
}) => ({
  pageCategory,
  selectedFilters,
  currentTotalCount,
  locale,
})

export default WithListingPageContext(mapStateToProps)(memo(SubscribeCard))
